import type { ColumnValidation } from '@atlassian/jira-platform-board-kit';
import type { BoardColumn } from '../../types';
import messages from './messages';

export const convertStatusNameForComparison = (statusName: string) => statusName.toUpperCase();

// Remove entire folder when jwm.board-awesome-enhancements is cleaned up
export const validateColumnName = (
	columns: Partial<BoardColumn>[],
	name: string,
): ColumnValidation => {
	if (
		columns.some(
			(col) =>
				// @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
				convertStatusNameForComparison(col.name) === convertStatusNameForComparison(name),
		)
	) {
		return {
			isValid: false,
			message: {
				title: messages.nameIsTakenTitle,
				description: messages.nameIsTakenDescription,
			},
		};
	}

	return { isValid: true, message: null };
};
